import { useEffect, useState } from 'react';
import { IOption } from 'interfaces';
import { equipmentService } from 'services/api';

export const useAccessorEquipmentOptions = () => {
  const [equipments, setEquipments] = useState<IOption[]>([]);

  useEffect(() => {
    equipmentService.getAllBaseInformation().then((res) => {
      setEquipments(
        res.map((eq) => ({
          id: +eq.id,
          code: `${eq.description} (SN ${eq.serial_number}) - (ID. ${eq.internal_id})`
        }))
      );
    });
  }, []);

  return { equipments };
};
